<template>
  <el-table :data="items" size="small" class="mt-10" v-loading="loading">
    <el-table-column
      :label="category == 1 ? `编号（数量）` : '编号'"
      prop="code"
    >
      <template slot-scope="scope">
        <template v-if="category == 1">
          <template v-if="scope.row.code_type == 2">
            {{ `${scope.row.code}（x${scope.row.number}）` }}
          </template>
          <ProductDialog :model="scope.row" v-else>{{
            scope.row.code
          }}</ProductDialog>
        </template>
        <ItemLink v-else :model="scope.row">{{ scope.row.code }}</ItemLink>
      </template>
    </el-table-column>
    <el-table-column label="名称" prop="name"></el-table-column>
    <el-table-column label="库存基地" prop="base.name"></el-table-column>
  </el-table>
</template>

<script>
export default {
  props: {
    items: null,
    loading: false,
    category: Number,
  },
}
</script>
